// Mobile navigation elements
const mobileNav = document.querySelector("[data-mobile-nav]");
const mobileBtnTrigger = document.querySelector("[data-btn-mobile-nav-trigger]");
const closeNavButtons = document.querySelectorAll("[data-close-mobile-nav]");

// Toggle mobile navigation visibility
const toggleMobileNav = () => {
  mobileBtnTrigger.classList.toggle("open-menu");
  mobileNav.classList.toggle("open-menu");
  document.body.classList.toggle("hidden");
  document.documentElement.classList.toggle("hidden");
};

mobileBtnTrigger?.addEventListener("click", toggleMobileNav);

closeNavButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    mobileNav.classList.remove("open-menu");
    mobileBtnTrigger.classList.remove("open-menu");
    document.body.classList.remove("hidden");
    document.documentElement.classList.remove("hidden");
  });
});

// Handle opening/closing submenus in mobile navigation
const mobileNavItems = document.querySelectorAll("[data-has-childen-mobile-nav]");

const resetAllMobileNavItems = () => {
  mobileNavItems.forEach((item) => {
    item.classList.remove("active");
    const childList = item.querySelector("[data-list-chridren-mobile-nav]");
    if (childList) childList.style.height = "0px";
  });
};

const toggleMobileNavItem = (item) => {
  const childList = item.querySelector("[data-list-chridren-mobile-nav]");
  const isActive = item.classList.contains("active");

  resetAllMobileNavItems();

  if (!isActive && childList) {
    item.classList.add("active");
    childList.style.height = `${childList.scrollHeight}px`;
  }
};

mobileNavItems?.forEach((item) => {
  item.addEventListener("click", () => toggleMobileNavItem(item));
});

const updateMobileNavHeight = () => {
  const topbar = document.querySelector("[data-topbar]");
  let topbarVisibleHeight = 0;

  if (topbar) {
    const rect = topbar.getBoundingClientRect();
    // Sprawdzenie, czy topbar jest w zasięgu widocznego obszaru (viewportu)
    if (rect.bottom > 0) {
      topbarVisibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    }
  }

  const nav = document.querySelector("[data-nav-site]");
  let navVisibleHeight = 0;

  if (nav) {
    const rectNav = nav.getBoundingClientRect();
    // Sprawdzenie, czy topbar jest w zasięgu widocznego obszaru (viewportu)
    if (rectNav.bottom > 0) {
      navVisibleHeight = Math.min(rectNav.bottom, window.innerHeight) - Math.max(rectNav.top, 0);
    }
  }

  if (mobileNav) {
    mobileNav.style.height = `calc(100dvh - ${navVisibleHeight}px - ${topbarVisibleHeight}px)`;
  }
};

window.addEventListener("load", updateMobileNavHeight);
window.addEventListener("resize", updateMobileNavHeight);
window.addEventListener("scroll", updateMobileNavHeight);
